import {User} from './user.model';
import {RelationUserEnum} from '../enums/relation-user.enum';
import {FamilySituationEnum} from '../enums/family-situation.enum';

export class RelationUser {
    id?: number;
    idUser?: number;
    idUserRelative?: number;
    relationUserEnum?: RelationUserEnum;
    familySituation?: FamilySituationEnum;
    dateUpdate?: Date;
    job?: string;

    user?: User;
    relative?: User;

    static assign(relationUser: RelationUser, relationUserInput: unknown) {
        Object.assign(relationUser, relationUserInput);
    }
}
